window.addEventListener('load', () => {
    let searchModalToggles = document.querySelectorAll('[data-toggle-search-modal]');
    let searchModal = document.querySelector('[data-search-modal]');

    if (searchModal) {
        for (let searchModalToggle of searchModalToggles) {
            searchModalToggle.addEventListener('click', () => {
                if (searchModal.dataset.open === 'false') {
                    searchModal.dataset.open = 'true';
                    searchModal.querySelector('input').focus();
                    document.addEventListener("keydown", (e) => {
                        if (e.key === "Escape") {
                            searchModal.dataset.open = 'false';
                        }
                    });
                } else {
                    searchModal.dataset.open = 'false';
                    searchModal.querySelector('input').value = '';
                }
            });
        }
    }
});
